import cjson from 'compressed-json';
import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { JdDataService } from 'src/app/jd-data.service';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Component({
    selector: 'app-report-education-tab',
    templateUrl: './report-education-tab.component.html',
    styleUrls: ['./report-education-tab.component.scss'],
    standalone: false
})
export class ReportEducationTabComponent implements OnInit {

  constructor(private fusionChartService: FusionChartsService, private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService, private router: Router, private jdService: JdDataService,
  private talentInsightsReqHandlerService: TalentInsightsReqHandlerService, private aggReqObjectHandlerService: AggReqObjectHandlerService,
  private aggService: AggregationService, private filterDataHandlerService: FilterDataHandlerService,
  private hashService: HashService, private talentInsightsService: TalentInsightsService, private route: ActivatedRoute) {
    const statemanagementSub = this.location.subscribe((p) => {
                const urlParams = new URLSearchParams(p.url.split('?')[1]);
                const filterKey = urlParams.get('filter');
                if (filterKey) {
                  const cacheRequest = localStorage.getItem(filterKey);
                  if (cacheRequest) {
                    const filterData = cjson.decompress(JSON.parse(cacheRequest));
                    this.filterDataHandlerService.setFilterData(filterData);
                  }
                }
                this.setUpdatedData(null);
    });
  }
  companyDetails: any;
  currentCompanyName: any;
  school: any = [];
  schoolData: any = [];
  schoolNames: any;
  @ViewChild('educationTbSort') schoolsTbSort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count' ,'recentGraduate', 'graph'];
  totalResultCount: number = 0;
  startindex: number = 0;
  education: any = [];
  fieldOfStudy: any = [];
  aggregatescount: number = 50;
  isViewMore: boolean = true;
  showSchoolLoader: boolean = true;
  showEducationLoader: boolean = true;
  showFieldOfStudyLoader: boolean = true;
  totalSchoolCount:any;
  recentGraduated: any [] = [];

  pagination: boolean = true;
  pageSize = 10;
  start: number = 0;
  end: number = 10;
  currentPage = 1;
  totalCount = 0;
  talentfilterdata: any = {};
  subscriptions: Array<Subscription> = [];

  /**School sorted data for shown pages */
  schoolsSortData = [];
  /**Recent Graduate data called or not */
  isRecentGraduateData: boolean = false;
  schoolsdata: any = []
  schoolsdataAI: any = {}
  educationdata: any = [];
  fieldofstudydata: any = [];
  insightsExportSubscription: Subscription = null;
  filters: any;
  isComingFromJD: boolean = false;
  isComingFromNLSearch: boolean = false;

    /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
    tableHeaderObj = {
      "Schools" : "Schools",
      "TalentCount": "Talent Count",
      "RecentGraduate": "Recent Graduate",
      "%OfTotal": "% of Total"
    }

    /**
     * Used to send as payload for export pdf.
     * Use key that need to be shown in pdf.
     * Must follow correct order as used in HTML file
     */
    tableHeaderName: string[] = [];

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if(!hasEUPSAccess )
    return this.localstorageservice.getItem('talentRegion') == 'europe';
  }

  ngOnInit(): void {
        if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
        if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;

      this.setUpdatedData(null);
      const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.setUpdatedData());
      this.subscriptions.push(filterMethodEvent);

      // subscribe to insights-export subject for processing request from parent
      this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
        if(requestData && requestData.type === 'SIGNAL') {
          this.shareDataForInsightsExport(requestData);
        }
      });
      this.subscriptions.push(this.insightsExportSubscription);

      const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res:any)=>{
        if(res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.EDUCATION){
          this.setUpdatedData();
        }
      });
      this.subscriptions.push(jdUpdateEvent);
  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
   // this.getTotalSchoolCount();
    this.getSchool();
    this.getEducation();
    this.getFieldOfStudy();
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  setPage(index: number){
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;
    if(this.aggregatescount / this.pageSize <= index){
      this.aggregatescount = this.aggregatescount + this.pageSize;
      this.getSchool();
    }
    else{
      this.manualSort();
    }
  }

  getSchoolTotalPercentage(value) {
   const p = ((value / this.totalSchoolCount) * 100).toFixed(2);
    if(p){
      return p
    }
  }


  getSchool() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "school";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.totalResultCount = response.data.totalresultscount;
      this.totalSchoolCount = response.data.totalresultscount;
      this.showSchoolLoader = false;
      const filterData = this.filterDataHandlerService.fetchFilterData;
      const filterSchool = filterData && filterData.schoolSelectedList && filterData.schoolSelectedList.length ? filterData.schoolSelectedList: [];
      const filterMap = new Map();

      filterSchool.map(item => {
        filterMap.set(item.key, true);
      })
      const tempData = filterSchool.length ? response.data.aggregations.school.filter(x => filterMap.get(x.key)) : response.data.aggregations.school;
      this.totalCount = tempData.length;

      this.schoolsSortData = tempData;
      this.schoolNames = _.pluck(this.schoolsSortData, 'key');
      this.schoolData = tempData.slice(this.start, this.end);
      this.school = new MatTableDataSource(this.schoolData);
      this.school.sort = this.schoolsTbSort;
      this.isRecentGraduateData = false;
      this.getRecentGraduated()
      this.manualSort();
    });
  }

  manualSort(){
    this.reSortArr(this.schoolsTbSort);
  }

  /**Sort the data including all shown pages */
  reSortArr(sort){
    const data = this.schoolsSortData;
    if(!sort || !sort.active || sort.direction === ''){
      this.schoolData = data.slice(this.start, this.end);
      this.school = new MatTableDataSource(this.schoolData);
      this.school.sort = this.schoolsTbSort;
      return;
    }

    this.schoolsSortData = data.sort((a,b)=>{
      const isAsc = sort.direction === 'asc';
      switch(sort.active){
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'recentGraduate': return this.compare(a.recentGraduate, b.recentGraduate, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
      }
    });

    this.schoolData = this.schoolsSortData.slice(this.start, this.end);
    this.school = new MatTableDataSource(this.schoolData);
    this.school.sort = this.schoolsTbSort;
  }

  compare(a:number, b:number, isAsc:boolean){
    return(a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getRecentGraduated(){
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'recentgraduate-school';
    aggReq.searchviaboolean = true;
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.recentgraduatesonly = true;
    aggReq.resultsize = 5;
    aggReq.startindex = 0;
    aggReq.schools = this.schoolNames;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((res) => {
      if(res && res.data && res.data.aggregations && res.data.aggregations['recentgraduate-school']){
        const tempData = res.data.aggregations['recentgraduate-school'];

        this.schoolsSortData.map(res=>{
          const filteredData = tempData.filter(x=>x.key.toLowerCase().trim() == res.key.toLowerCase().trim())[0];
          res.recentGraduate = filteredData && filteredData.doc_count ? filteredData.doc_count : 0;
          this.isRecentGraduateData = true;
          return res;
        })
        this.getschoolsdataai(this.schoolsSortData, 'schools')
      }
    });
  }

  getEducation() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "education";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      const data = response.data.aggregations.education.slice(0, 5);
      this.getschoolsdataai(response.data.aggregations.education, 'educations')
      this.showEducationLoader = false;

      this.education = this.fusionChartService.educationChart(data);
    });
  }

  getFieldOfStudy() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "fieldofstudy";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.considerfilterforaggregates = true;

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      const data = response.data.aggregations.fieldofstudy;
      this.showFieldOfStudyLoader = false;
      data.sort((a, b) => b.doc_count - a.doc_count);
      this.fieldOfStudy = this.fusionChartService.fieldOfStudyChart(data);
    });
  }

  getTotalSchoolCount() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.startindex = 0;
    aggReq.calledfrom = "listing";
    aggReq.resultsize = 10;
    aggReq.currentcompaniesonly = false;
    aggReq.fullnames = [];
    aggReq.iscurrent = false;
    aggReq.pastcompaniesonly = false;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getPersonSearchRecommendCandidates(aggReq).subscribe((res:any)=>{
      if(res && res.data){
        this.totalSchoolCount = res.data.totalresultscount;
      }
    })
  }

convertToTitleCase(stringName){
  stringName = stringName.toLowerCase().split(' ');
  for(let i = 0;i<stringName.length;i++){
    stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
  }
  return stringName.join(' ');
}

ngOnDestroy() {
  this.subscriptions.forEach(sub => sub.unsubscribe());
}

/**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if(this.isLocationEurope) return;
 this.filters = this.filterDataHandlerService.fetchFilterData;

      const redirectFilters: Partial<FilterParams> = {
        insightsFilterData: this.filters,
      };
    switch(type) {
      case 'school': redirectFilters['mandatoryschools'] = [key]; break;
      case 'recentgraduatesonly': {
        redirectFilters['mandatoryschools'] = [key];
        redirectFilters['recentgraduatesonly'] = true;
        break;
      }
    }

    const aggReq = this.aggService.getRequestWithFilters();
            if (aggReq?.continentstobeincluded) {
              redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
            }
            if (aggReq?.nlsearchquery) {
              redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
            }

            const uniqueKey = this.hashService.generateUniqueHash();
            localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

            // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
            // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
            // that window.open() clones into the new tab.
            const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

            let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

            if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
              url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
            }

            window.open(url, '_blank');
  }

  getschoolsdataai(data, type) {
    this.schoolsdataAI = {};
    if(type == 'schools') {

      this.schoolsdata = data.map(x=>{
        let res: any ={};
        res['Schools'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Recent Graduate'] = x.recentGraduate;
        res['% of Total'] = this.getSchoolTotalPercentage(x.doc_count)+'%';
        return res;
      });
      if(this.schoolsdata.length > 0)
        this.schoolsdataAI['schools'] = this.schoolsdata;
    } if(type == 'educations') {
      this.educationdata = data.map(x=>{
        let res:any = {};
        res['Qualifications'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
      if(this.educationdata.length > 0)
      this.schoolsdataAI['educations'] = this.educationdata;
    } if(type == 'fieldofstudy') {
      this.fieldofstudydata = data.map(x=>{
        let res:any = {};
        res['Field of Study'] = x.key;
        res['Talent Count'] = x.doc_count;
        return res;
      })
      if(this.fieldofstudydata.length > 0)
      this.schoolsdataAI['fieldofstudies'] = this.fieldofstudydata;
    }
    if(this.schoolsdata.length == 0 && this.educationdata.length == 0 && this.fieldofstudydata.length == 0)
      this.schoolsdataAI = null;

  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if(requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.EDUCATION) return;

    this.tableHeaderName = [this.tableHeaderObj['Schools'], this.tableHeaderObj['TalentCount'], this.tableHeaderObj['RecentGraduate'], this.tableHeaderObj['%OfTotal']];

    // education chart config
    const educationChart = { renderAt: 'education', type: 'column2d', dataSource: { ...this.education } };
    educationChart['type'] = educationChart['dataSource']['type'];
    delete educationChart['dataSource']['type'];
    delete educationChart['dataSource']['width'];
    delete educationChart['dataSource']['chart']['width'];
    delete educationChart['dataSource']['height'];
    delete educationChart['dataSource']['chart']['height'];
    delete educationChart['dataSource']['chart']['renderAt'];
    educationChart['width'] = '100%';

    // field-of-study chart config
    const fieldOfStudyChart = { renderAt: 'fieldofstudy', dataSource: { ...this.fieldOfStudy } };
    fieldOfStudyChart['type'] = fieldOfStudyChart['dataSource']['type'];
    delete fieldOfStudyChart['dataSource']['type'];
    delete fieldOfStudyChart['dataSource']['width'];
    delete fieldOfStudyChart['dataSource']['chart']['width'];
    delete fieldOfStudyChart['dataSource']['height'];
    delete fieldOfStudyChart['dataSource']['chart']['height'];
    fieldOfStudyChart['dataSource']['chart']['legendPosition'] = 'bottom';
    fieldOfStudyChart['dataSource']['chart']['legendNumColumns'] = '4';
    fieldOfStudyChart['width'] = '100%';

    const payloadForInsightsExport = {
      tab: 'education',
      totalresultcount: this.totalResultCount,
      school: this.schoolsSortData,
      chartdetails: [educationChart, fieldOfStudyChart],
      tableHeader: this.tableHeaderName
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }
}
